function cov_3n62nkc8h() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/PrivacyPolicy/PrivacyPolicy.tsx";
  var hash = "565fc5d33a2eff67143b01d8592b3c6003c45bf8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/PrivacyPolicy/PrivacyPolicy.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 50
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 25,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 50
          },
          end: {
            line: 5,
            column: 51
          }
        },
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 25,
            column: 9
          }
        },
        line: 6
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "565fc5d33a2eff67143b01d8592b3c6003c45bf8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3n62nkc8h = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_3n62nkc8h();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Text, Image, Flex, Link } from '@opendoor/bricks/core';
/** TODO: Add documentation */

cov_3n62nkc8h().s[0]++;
export var PrivacyPolicy = function PrivacyPolicy(props) {
  cov_3n62nkc8h().f[0]++;
  cov_3n62nkc8h().s[1]++;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "https://imgdrop.imgix.net/0d660b01ccca4a2a90a2d896ddb6b5c7.svg",
    alt: "",
    height: "16px"
  }), /*#__PURE__*/React.createElement(Text, _extends({
    fontSize: "s00",
    lineHeight: "s000",
    color: "neutrals70",
    ml: 3
  }, props), "Your information is protected by our", ' ', /*#__PURE__*/React.createElement(Link, {
    analyticsName: "privacy-policy",
    href: "https://www.opendoor.com/w/privacy",
    display: "inline",
    target: "_blank",
    "aria-label": "Opens a new page with Opendoor's privacy policy"
  }, "Privacy Policy"), "."));
};